import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetChallengeRequest } from './get-challenge-request';
import type { IGetChallengeResponse } from './get-challenge-response';
import { getChallengeResponseSchema } from './get-challenge-response';

export async function getChallengeApi({
  id,
}: IGetChallengeRequest): Promise<IValidatedResponse<IGetChallengeResponse>> {
  return getRequest<IGetChallengeResponse>({
    path: `/sys/challenges/${id}`,
    schema: getChallengeResponseSchema,
  });
}
